import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { HttpResponse, Interview, InterviewQueryParams } from "@/types";

export function useDuplicateAddInterview({
  companyId,
  jobId,
  queryParams,
}: {
  companyId: string;
  jobId: string;
  queryParams: InterviewQueryParams;
}) {
  const queryClient = useQueryClient();
  const queryString = misc.prepareQueryParams(queryParams).toString();

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const path = `companies/${companyId}/jobs/${jobId}/interviews/${id.toString()}/duplicate`;
      const res = await guacHttpClient.post<Interview, HttpResponse<Interview>>(
        path,
      );

      return res.data;
    },
    onSuccess: (duplicatedInterview) => {
      queryClient.setQueryData(
        ["interviews", companyId, jobId, queryString],
        (cachedData?: Interview[]) => {
          if (!cachedData) return [duplicatedInterview];
          return [...cachedData, duplicatedInterview];
        },
      );
    },
  });
}
